import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/auth";

const KEY = "rail_show_prices";
const ShowPricesCtx = createContext({ showPrices: false, setShowPrices: () => {} });

export function ShowPricesProvider({ children }) {
  const { user } = useAuth();
  const [stored, setStored] = useState(() => {
    try {
      return localStorage.getItem(KEY) === "true";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(KEY, String(stored));
    } catch {}
  }, [stored]);

  // Listen for cross-tab changes so toggling on one tab refreshes others.
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY) setStored(e.newValue === "true");
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  // Hard rule: only admins can ever see prices. Sales & viewers always get
  // showPrices=false regardless of the stored toggle.
  const isAdmin = user?.role === "admin";
  const showPrices = isAdmin && stored;

  return (
    <ShowPricesCtx.Provider value={{ showPrices, setShowPrices: setStored }}>
      {children}
    </ShowPricesCtx.Provider>
  );
}

export const useShowPrices = () => useContext(ShowPricesCtx);
